import { z } from "zod";
import { DOCUMENT_TYPE } from "./consts";
 
export const schema = z.object({
  [DOCUMENT_TYPE]: z.string().min(1, "This Field is required"),
});

export type formValues = z.infer<typeof schema>;
